const motors = function (robotType, blockSeparator, categorySeparator) {
    switch (robotType) {


        case 'E6':
            return `
                <category
                    name="%{BKY_CATEGORY_MOTOR}"
                    id="motor"
                    colour="#c19e61"
                    secondaryColour="#986b1c"
                    showLabelButton="true">
                <block type="motor_setMotor">
                    <value name="VALUE">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setServoMotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_waitServomotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_setMotorCode"/>
                <block type="motor_getMotorCode"/>
                ${blockSeparator}
                <block type="motor_setLinearSpeed">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="PULSE">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                <block type="motor_setTurnSpeed">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="PULSE">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                <block type="motor_setMotorStraight">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setMotorStraightTurn">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_two">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_setMotorPower">
                    <value name="MOTORONE">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORTWO">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORTHREE">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORFOUR">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                </category>
                `;


        case 'C1':
            return `<category
                            name="%{BKY_CATEGORY_MOTOR}"
                            id="motor"
                            colour="#c19e61"
                            secondaryColour="#986b1c"
                            showLabelButton="true">
                        <block type="motor_setMotor_C1">
                            <value name="VALUE">
                                <shadow type="motor_speed_menu">
                                </shadow>
                            </value>
                        </block>
                        <block type="motor_setServoMotor_C1">
                            <value name="ANGLE">
                                <shadow type="motor_angle_menu">
                                </shadow>
                            </value>
                        </block>
                        <block type="motor_setMotorPower_C1">
                            <value name="MOTORONE">
                                <shadow type="math_number">
                                    <field name="NUM">100</field>
                                </shadow>
                            </value>
                            <value name="MOTORTWO">
                                <shadow type="math_number">
                                    <field name="NUM">100</field>
                                </shadow>
                            </value>
                        </block>
                        ${blockSeparator}
                        </category>
                    `;

        case 'E3':
            return `<category
                        name="%{BKY_CATEGORY_MOTOR}"
                        id="motor"
                        colour="#c19e61"
                        secondaryColour="#986b1c"
                        showLabelButton="true">
                    <block type="motor_setMotor">
                        <value name="VALUE">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="motor_getMotorCode"/>
                    <block type="motor_setMotorCode"/>
                    <block type="motor_setServoMotor">
                        <value name="SPEED">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="motor_setServoMotor128">
                        <value name="SPEED">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="motor_setLinearSpeed">
                        <value name="SPEED">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="PULSE">
                            <shadow type="math_number">
                                <field name="NUM">1000</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="motor_setTurnSpeed">
                        <value name="SPEED">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="PULSE">
                            <shadow type="math_number">
                                <field name="NUM">1000</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="motor_setMotorPower">
                        <value name="MOTORONE">
                            <shadow type="math_number">
                                <field name="NUM">100</field>
                            </shadow>
                        </value>
                        <value name="MOTORTWO">
                            <shadow type="math_number">
                                <field name="NUM">100</field>
                            </shadow>
                        </value>
                        <value name="MOTORTHREE">
                            <shadow type="math_number">
                                <field name="NUM">100</field>
                            </shadow>
                        </value>
                        <value name="MOTORFOUR">
                            <shadow type="math_number">
                                <field name="NUM">100</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="motor_setServo_E3">
                        <value name="ANGLE">
                            <shadow type="motor_angle_menu_three">
                            </shadow>
                        </value>
                    </block>
                    <block type="motor_setServoTime_E3">
                        <value name="ANGLE">
                            <shadow type="motor_angle_menu_three">
                            </shadow>
                        </value>
                        <value name="TIME">
                            <shadow type="math_number">
                                <field name="NUM">1000</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="motor_setOneServo">
                        <value name="CHANNEL">
                            <shadow type="math_number">
                                <field name="NUM"></field>
                            </shadow>
                        </value>
                        <value name="ANGLE">
                            <shadow type="motor_angle_menu_three">
                            </shadow>
                        </value>
                        <value name="TIME">
                            <shadow type="math_number">
                                <field name="NUM"></field>
                            </shadow>
                        </value>
                    </block>
                    
                    <block type="E3_motor_setMagneticServoDegreeTime">
                        <value name="ANGLE">
                            <shadow type="math_number">
                                <field name="NUM">90</field>
                            </shadow>
                        </value>
                        <value name="TIME">
                            <shadow type="math_number">
                                <field name="NUM">1000</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="E3_motor_setMagneticServoDegreeSpeed">
                        <value name="ANGLE">
                            <shadow type="math_number">
                                <field name="NUM">90</field>
                            </shadow>
                        </value>
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">50</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="E3_motor_setMagneticServoCodeMotor">
                        <value name="ANGLE">
                            <shadow type="math_number">
                                <field name="NUM">360</field>
                            </shadow>
                        </value>
                        <value name="SPEED">
                            <shadow type="math_number">
                                <field name="NUM">50</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="E3_motor_setSeeringEngine">
                        <value name="ANGLE">
                            <shadow type="math_number">
                                <field name="NUM">135</field>
                            </shadow>
                        </value>
                    </block>
                    <block type="E3_motor_setSeeringEngineTime">
                        <value name="ANGLE">
                            <shadow type="math_number">
                                <field name="NUM">135</field>
                            </shadow>
                        </value>
                        <value name="TIME">
                            <shadow type="math_number">
                                <field name="NUM">1000</field>
                            </shadow>
                        </value>
                    </block>
                    ${blockSeparator}
                    </category>
                    `;
        case 'M6':
            return `
                <category
                    name="%{BKY_CATEGORY_MOTOR}"
                    id="motor"
                    colour="#c19e61"
                    secondaryColour="#986b1c"
                    showLabelButton="true">
                <block type="motor_setMotor">
                    <value name="VALUE">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setServoMotor48">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_waitServomotor48">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_getMotorCode"/>
                <block type="motor_setMotorCode"/>
                ${blockSeparator}
                <block type="motor_setServoMotor128">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_waitservomotor128">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="M6_motor_setServoMotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="M6_motor_waitservomotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_setLinearSpeed">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="PULSE">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                <block type="motor_setTurnSpeed">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="PULSE">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                <block type="motor_setMotorStraight">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setMotorStraightTurn">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_two">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_setMotorPower">
                    <value name="MOTORONE">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORTWO">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORTHREE">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORFOUR">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                </category>
                `;
        case 'C6':
            return `
                <category
                    name="%{BKY_CATEGORY_MOTOR}"
                    id="motor"
                    colour="#c19e61"
                    secondaryColour="#986b1c"
                    showLabelButton="true">
                <block type="motor_setMotor">
                    <value name="VALUE">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setServoMotor48">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_waitServomotor48">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_getMotorCode"/>
                <block type="motor_setMotorCode"/>
                ${blockSeparator}
                <block type="motor_setServoMotor128">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_waitservomotor128">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="M6_motor_setServoMotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="M6_motor_waitservomotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_setLinearSpeed">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="PULSE">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                <block type="motor_setTurnSpeed">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="PULSE">
                        <shadow type="math_number">
                            <field name="NUM">1000</field>
                        </shadow>
                    </value>
                </block>
                <block type="motor_setMotorStraight">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setMotorStraightTurn">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_two">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_setMotorPower">
                    <value name="MOTORONE">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORTWO">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORTHREE">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                    <value name="MOTORFOUR">
                        <shadow type="math_number">
                            <field name="NUM">100</field>
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                </category>
                `;
        case 'E7':
            return `
                <category
                    name="%{BKY_CATEGORY_E7_MOTOR}"
                    id="motor"
                    colour="#c19e61"
                    secondaryColour="#986b1c"
                    showLabelButton="true">
                <block type="motor_setMotorVByOther">
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>
                <block type="motor_setMotor_E7">
                    <value name="VALUE">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_stopMotor"/>
                <block type="motor_setSteeringAngle">
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_four">
                        </shadow>
                    </value>
                    <value name="TIME">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>

                <block type="E7_motor_getMotorCode"/>
                <block type="E7_motor_getMotorAngle"/>
                <block type="E7_motor_getMotorV"/>
                <block type="E7_motor_setMotorCode"/>
                
                <block type="motor_waitMotorTo">
                    <value name="SPEED">
                        <shadow type="math_number">
                            <field name="NUM">50</field>
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="math_number">
                            <field name="NUM">1</field>
                        </shadow>
                    </value>
                </block>
                
                
                ${false && <block type="motor_setMotorPowerIs"></block>}
                ${blockSeparator}
                </category>
                `;

        case 'STORM_OS':
            return `
                <category
                    name="%{BKY_CATEGORY_MOTOR}"
                    id="motor"
                    colour="#c19e61"
                    secondaryColour="#986b1c"
                    showLabelButton="true">
                    <block type="STORM_OS_set_motor_speed">
                        <value name="SPEED">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_set_motors_speed">
                        <value name="SPEED1">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="SPEED2">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="SPEED3">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="SPEED4">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_get_motor_code"/>
                    <block type="STORM_OS_get_motors_code"/>
                    <block type="STORM_OS_clear_motor_code"/>
                    <block type="STORM_OS_clear_motors_code"/>
                    <block type="STORM_OS_set_motor_servo_asyn">
                        <value name="SPEED">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_set_motors_servo_asyn">
                        <value name="SPEED1">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="SPEED2">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="SPEED3">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="SPEED4">
                            <shadow type="motor_speed_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE1">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE2">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE3">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE4">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_motor_servo_unlock"/>
                    <block type="STORM_OS_motors_servo_unlock"/>
                    
                    <block type="STORM_OS_set_steering">
                        <value name="ANGLE">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_set_steerings">
                        <value name="ANGLE1">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE2">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE3">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_set_steering_unlock">
                        <value name="ANGLE">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_set_steerings_unlock">
                        <value name="ANGLE1">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE2">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                        <value name="ANGLE3">
                            <shadow type="motor_angle_menu">
                            </shadow>
                        </value>
                    </block>
                    <block type="STORM_OS_steering_unlock"/>
                    <block type="STORM_OS_steerings_unlock"/>
                ${blockSeparator}
                </category>
                
                <block type="motor_setMotor">
                    <value name="VALUE">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_getMotorCode"/>
                <block type="motor_setMotorCode"/>
                <block type="motor_setServoMotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_setServo_OS">
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_three">
                        </shadow>
                    </value>
                </block>
                `;


        case 'M5':
            return `
                <category
                    name="%{BKY_CATEGORY_MOTOR}"
                    id="motor"
                    colour="#c19e61"
                    secondaryColour="#986b1c">
                <block type="motor_M5_setMotor">
                    <value name="VALUE">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_M5_SetServo">
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu_three">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_M5_SetServoMotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                <block type="motor_M5_WaitServomotor">
                    <value name="SPEED">
                        <shadow type="motor_speed_menu">
                        </shadow>
                    </value>
                    <value name="ANGLE">
                        <shadow type="motor_angle_menu">
                        </shadow>
                    </value>
                </block>
                ${blockSeparator}
                <block type="motor_M5_SetMotorCode"/>
                <block type="motor_M5_GetMotorCode"/>
                ${blockSeparator}
                </category>
                `;
        default:
            return `<category
                        name="%{BKY_CATEGORY_MOTOR}"
                        id="motor"
                        colour="#c19e61"
                        secondaryColour="#986b1c">
                    </category>
                    `;
    }
};

export default motors;
